import auth from 'middlewares/auth';

const headers = (isPublic) => {
    if (tokenWithValidations(isPublic)) {
        return {
            ...commonHeaders,
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    return commonHeaders;
}

const tokenWithValidations = (isPublic) => {
    return !isPublic && auth.getToken();
}

const commonHeaders = {
    accept: 'application/json',
    'Content-Type': 'application/json',
}

export default headers;